<template>
  <div>
    <h1 class="page-title text-left">Service Request</h1>
    <div class="panel">
      <div class="panel-heading">
        <h3 class="panel-title">
          Details
          <router-link
            :to="{ name: 'data-service-requests' }"
            class="pull-right ml-10"
            ><i class="fa fa-list"></i
          ></router-link>
          <i
            class="fa fa-pencil pointer pull-right"
            v-on:click="form.showEdit({ id: id, list: true })"
          ></i>
        </h3>
      </div>
      <div class="panel-body">
        <dl class="dl-horizontal">
          <dt>Call Date</dt>
          <dd>{{ form.data.serviceDate | date }}</dd>

          <dt>Contract</dt>
          <dd>{{ contractName(form.data.contractId) }}</dd>

          <dt>Request Id</dt>
          <dd>{{ form.data.inspectionId }}</dd>

          <dt>Name</dt>
          <dd>{{ form.data.name }}</dd>

          <dt>Address</dt>
          <dd
            class="pointer"
            v-on:click="
              showMap(
                `${form.data.address}, ${form.data.city} ${stateName(
                  form.data.stateId
                )} ${form.data.zip} `
              )
            "
          >
            <i class="fa fa-map"></i>
            {{ form.data.address }}<br />
            {{ form.data.city }}, {{ stateName(form.data.stateId) }}
            {{ form.data.zip }}
          </dd>

          <dt>Phone</dt>
          <dd>
            <i class="fa fa-sun-o"></i> {{ form.data.phoneDay }}<br />
            <i class="fa fa-moon-o"></i> {{ form.data.phoneNight }}
          </dd>

          <dt>Zone</dt>
          <dd>{{ zoneName(form.data.zoneId) }}</dd>

          <dt>Municipality</dt>
          <dd>{{ municipalityName(form.data.municipalityId) }}</dd>

          <dt>Inspector</dt>
          <dd>{{ applicatorName(form.data.applicatorId) }}</dd>

          <dt>Assigned to inspector</dt>
          <dd>
            <i
              class="fa"
              :class="{
                'fa-check-square-o': form.data.assignedToInspector,
                'fa-square-o': !form.data.assignedToInspector,
              }"
            ></i>
          </dd>

          <dt>Inspection Date</dt>
          <dd>{{ form.data.inspectionDate | date }}</dd>

          <dt>Coordinates</dt>
          <dd
            class="pointer"
            v-on:click="
              showMap({ lat: form.data.latitude, lon: form.data.longitude })
            "
          >
            <i class="fa fa-map"></i> {{ form.data.latitude }},
            {{ form.data.longitude }}
          </dd>

          <dt>Work Status</dt>
          <dd>{{ form.data.status }}</dd>
        </dl>

        <div class="btn-group pull-right">
          <router-link
            :to="{
              name: 'data-adulticide-with-sr',
              params: { type: 'sr', id: id, contractId: form.data.contractId },
            }"
            class="btn btn-primary"
            >Add Adulticide Data</router-link
          >
          <router-link
            :to="{
              name: 'data-larvicide-with',
              params: { type: 'sr', id: id },
            }"
            class="btn btn-primary"
            >Add Larvicide Data</router-link
          >
        </div>

        <div class="mt-20 clearfix">
          <!-- Nav tabs -->
          <ul class="nav nav-tabs" role="tablist">
            <li role="presentation" class="active">
              <a href="#adulticides" role="tab" data-toggle="tab"
                >Adulticices</a
              >
            </li>
            <li role="presentation">
              <a href="#larvicides" role="tab" data-toggle="tab">Larvicides</a>
            </li>
          </ul>

          <!-- Tab panes -->
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" id="adulticides">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Applicator</th>
                    <th>Chemical</th>
                    <th>Zone</th>
                    <th>Spray Start/End</th>
                    <th>Spray Miles</th>
                    <th>Ounces Sprayed</th>
                    <th>Work Status</th>
                    <th width="120"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="adulticide in form.data.adulticides">
                    <td>{{ applicatorName(adulticide.applicatorId) }}</td>
                    <td>{{ achemicalName(adulticide.achemicalId) }}</td>
                    <td>{{ zoneName(adulticide.zoneId) }}</td>
                    <td>
                      {{ adulticide.startTime }} - {{ adulticide.endTime }}
                    </td>
                    <td>{{ adulticide.sprayMiles }}</td>
                    <td>{{ adulticide.ouncesSprayed }}</td>
                    <td>{{ adulticide.workStatus }}</td>

                    <td>
                      <router-link
                        :to="{
                          name: 'data-adulticide-details',
                          params: { id: adulticide.id },
                        }"
                        ><i
                          class="fa fa-ellipsis-h"
                          style="margin-right: 10px;"
                        ></i
                      ></router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div role="tabpanel" class="tab-pane" id="larvicides">
              <div class="col-xs-12 table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Applicator</th>
                      <th>Temperature</th>
                      <th>Wind Speed</th>
                      <th>Wind Direction</th>
                      <th>Equipment Used</th>
                      <th>Eggs</th>
                      <th>Larvae</th>
                      <th>Pupae</th>
                      <th>Adults</th>
                      <th>Visual Monitoring</th>
                      <th>Control Action</th>
                      <th>Chemical</th>
                      <th>Amount (oz)</th>
                      <th>Appl. Rate</th>
                      <th>EPA Reg. No.</th>
                      <th>Area Treated (sq. ft.)</th>
                      <th>Sample Number</th>
                      <th>Wed/Dry</th>
                      <th>Service Request</th>
                      <th>Work Status</th>
                      <th>Predators</th>
                      <th>Biting Activity</th>
                      <th>Site Conditions</th>
                      <th>Larval Stages</th>
                      <th>% Breeding</th>
                      <th>% Culex</th>
                      <th>% Non Culex</th>
                      <th width="120"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="larvicide in form.data.larvicides">
                      <td>{{ larvicide.appliedDate | date }}</td>
                      <td>{{ larvicide.appliedTime }}</td>
                      <td>{{ applicatorName(larvicide.applicatorId) }}</td>
                      <td>{{ larvicide.temperature }}</td>
                      <td>{{ larvicide.windSpeed }}</td>
                      <td>{{ windDirection(larvicide.windDirectionId) }}</td>
                      <td>{{ equipmentName(larvicide.lequipmentId) }}</td>
                      <td>{{ larvaCountName(larvicide.eggs) }}</td>
                      <td>{{ larvaCountName(larvicide.larvae) }}</td>
                      <td>{{ larvaCountName(larvicide.pupae) }}</td>
                      <td>{{ larvaCountName(larvicide.adults) }}</td>
                      <td>
                        <i
                          class="fa"
                          :class="{
                            'fa-check-square-o':
                              larvicide.vizualMonitorPerformed,
                            'fa-square-o': !larvicide.vizualMonitorPerformed,
                          }"
                        ></i>
                      </td>
                      <td>{{ controlAction(larvicide.controlActionId) }}</td>
                      <td>{{ chemicalName(larvicide.lchemicalId) }}</td>
                      <td>{{ larvicide.amount }}</td>
                      <td>{{ larvicide.applicationRate }}</td>
                      <td>{{ larvicide.epaRegNumber }}</td>
                      <td>{{ larvicide.areaTreated }}</td>
                      <td>{{ larvicide.sampleNumber }}</td>
                      <td>{{ larvicide.wetDry }}</td>
                      <td>
                        <router-link
                          v-if="form.data.serviceRequestId"
                          :to="{
                            name: 'data-service-request-details',
                            params: { id: form.data.serviceRequestId },
                          }"
                          >view</router-link
                        >
                      </td>
                      <td>{{ larvicide.workStatus }}</td>
                      <td>
                        <i
                          class="fa"
                          :class="{
                            'fa-check-square-o': larvicide.predators,
                            'fa-square-o': !larvicide.predators,
                          }"
                        ></i>
                      </td>
                      <td>
                        <i
                          class="fa"
                          :class="{
                            'fa-check-square-o': larvicide.bitingActivity,
                            'fa-square-o': !larvicide.bitingActivity,
                          }"
                        ></i>
                      </td>
                      <td>{{ larvicide.siteConditions }}</td>
                      <td>{{ larvicide.lStages }}</td>
                      <td>{{ larvicide.percentBreeding }}</td>
                      <td>{{ larvicide.percentCulex }}</td>
                      <td>{{ larvicide.percentNonCulex }}</td>

                      <td>
                        <router-link
                          :to="{
                            name: 'data-larvicide-details',
                            params: { id: larvicide.id },
                          }"
                          ><i
                            class="fa fa-ellipsis-h"
                            style="margin-right: 10px;"
                          ></i
                        ></router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <site-form :form="form"></site-form>
    <google-map ref="gmap"></google-map>
  </div>
</template>

<script>
import ServiceRequestsService from '@/services/ServiceRequestsService';
import Form from '@/utils/form';
import loader from '@/utils/loader';
import siteForm from '@/components/forms/service_request';
import googleMap from '@/components/googleMap';

import store from '@/store';

export default {
  name: 'service_requests_details',

  components: {
    siteForm,
    googleMap,
  },

  props: ['id'],

  data() {
    return {
      form: new Form(ServiceRequestsService, {
        applicatorId: null,
      }),
    };
  },

  methods: {
    contractName(id) {
      return this.$store.getters.contractNameById(id);
    },
    municipalityName(id) {
      return this.$store.getters.municipalityNameById(id);
    },
    stateName(id) {
      return this.$store.getters.stateNameById(id);
    },
    zoneName(id) {
      return this.$store.getters.zoneNameById(id);
    },
    applicatorName(id) {
      return this.$store.getters.applicatorNameById(id);
    },
    larvaCountName(id) {
      return this.$store.getters.larvaCountNameById(id);
    },
    achemicalName(id) {
      return this.$store.getters.achemicalNameById(id);
    },
    windDirection(id) {
      return this.$store.getters.windDirectionNameById(id);
    },
    equipmentName(id) {
      return this.$store.getters.lEquipementNameById(id);
    },
    vizualMonitor(id) {
      return this.$store.getters.vizualMonitorNameById(id);
    },
    controlAction(id) {
      return this.$store.getters.controlActionNameById(id);
    },
    chemicalName(id) {
      return this.$store.getters.lChemicalNameById(id);
    },
    larvaCountName(id) {
      return this.$store.getters.larvaCountNameById(id);
    },
    showMap(coordinates) {
      this.$refs.gmap.showMap(coordinates);
    },
  },

  mounted() {
    loader.lookups().then(() => {
      this.form.getDetails(this.id);
    });
  },
};
</script>

<style lang="scss"></style>
